import styled from 'styled-components';

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
`;

export const DialogHeader = styled.div`
    justify-content: space-between;
    align-items: center;
    gap: 10;
    padding: 16px;
`;

export const TitleSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center !important;
  padding: 0 16px;
`;

export const SearchSection = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 13px;
`;

export const FiltersContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  padding: 8px 20px;
`;

export const FilterWrapper = styled.div`
  width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
`;